import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const RecoveryMail = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <div className="authBox">
        <h2 style={{ position: "relative" }}>
          <img 
            src="/static/images/back_arrow.svg" 
            alt="back" 
            onClick={() => navigate(-1)} 
            className="back_arrow"
            style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", cursor: "pointer", width: 24, height: 24 }}
          />
          Check Your Email
        </h2>
        <p className="subtitle" style={{ marginBottom: 10 }}>
          We've sent a recovery link to your email address
        </p>

        <div className="recovery_img_wrap" style={{ textAlign: "center", margin: "40px 0" }}>
          <img 
            src="/static/images/recovery_img.png" 
            alt="Recovery Email Sent" 
            style={{ maxWidth: "220px", height: "auto", display: "inline-block" }}
          />
        </div>

        <p className="subtitle" style={{ marginBottom: 40, lineHeight: 1.5 }}>
          Please check your inbox and click the verification link<br />
          to reset your security credentials.
        </p>

        <form className="form" onSubmit={(e) => { e.preventDefault(); navigate("/reset-password"); }}>
          <div className="form_btn" style={{ marginTop: 30 }}>
            <Button
              type="submit"
              className="btn btn_primary w_100"
            >
              Reset Password
            </Button>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default RecoveryMail;
